import { useMemo } from 'react'

const useAuth = () => {
  const token = localStorage.getItem('authToken')
  const userId = localStorage.getItem('userId')
  return useMemo(() => !!token && !!userId, [token, userId])
}

export default useAuth
